var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"map"}},[_c('img',{staticClass:"map",attrs:{"src":"http://api.tianditu.gov.cn/staticimage?center=117.472296,36.643129&width=800&height=400&zoom=10\n    &layers=vec_c,cva_c&zoom=14&markers=117.472296,36.643129&tk=129ed0fadb80f373ca5b00e1245ba0ec","alt":""}})])
}]

export { render, staticRenderFns }